const redux = require("redux");

const initialState = {
  responses: [],
};

const reducer = (state = { ...initialState }, action) => {
  const { type } = action;
  if (type === "SEED_RESPONSES") {
    const { fetchRes } = action;
    return {
      responses: fetchRes,
    };
  }
  else if (type === "ADD_RESPONSE") {
    const { payload } = action;
    const tempResponses = [...state.responses];
    tempResponses.push(payload);
    return {
        responses: tempResponses
    }
  }
  else{
      return state
  }
};

const store = redux.createStore(reducer);

export default store;
